import { REQUEST_STATUS__PENDING } from '../../../util/constants';

export const $isCancelUpdateBookingByAdminPending = state => {
  return state.AdminActionsUpdateBooking.cancelRequestStatus === REQUEST_STATUS__PENDING;
};

export const $isAcceptUpdateBookingByAdminPending = state => {
  return state.AdminActionsUpdateBooking.acceptRequestStatus === REQUEST_STATUS__PENDING;
};
